module.exports = __webpack_public_path__ + "img/macchina-laboratorio.eea07c39.jpg";